<template>
  <div id="contenedor-registrar-nueva-escalatoria">
    <v-form
      v-model="formularioValido"
      ref="registrarContratoEscalatoria">
      <v-card>
        <v-card-title>
          Registrar nueva Escalatoria
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <text-field
              v-model="escalatoria.numero"
              label="Número"
              cols="12"
              :rules="[mixReglas.requerido]">
            </text-field>
            <date-picker
              v-model="escalatoria.fechaDel"
              label="Fecha Del"
              :rules="[mixReglas.requerido]"
              cols="12"
              md="6">
            </date-picker>
            <date-picker
              v-model="escalatoria.fechaAl"
              label="Fecha Al"
              :rules="[mixReglas.requerido]"
              cols="12"
              md="6">
            </date-picker>
            <v-col
              cols="12">
              <v-divider></v-divider>
            </v-col>
            <custom-text-field-green
              cols="12"
              md="8"
              v-model.number="escalatoria.importe"
              label="Importe"
              es-dinero
              prefix="$"
              :rules="[mixReglas.requerido]"
              @keyup="calcularTotal">
            </custom-text-field-green>
            <custom-text-field-green
              cols="12"
              md="4"
              v-model.number="escalatoria.porcentajeIva"
              label="% I.V.A."
              suffix="%"
              es-dinero
              :rules="[mixReglas.requerido]"
              @keyup="calcularTotal">
            </custom-text-field-green>
            <custom-text-field-green
              cols="12"
              md="6"
              v-model="escalatoria.iva"
              label="Importe I.V.A."
              prefix="$"
              es-dinero
              readonly
              disabled>
            </custom-text-field-green>
            <custom-text-field-green
              cols="12"
              md="6"
              v-model="escalatoria.total"
              es-dinero
              label="Total"
              prefix="$"
              readonly
              disabled>
            </custom-text-field-green>
            <v-col
              cols="12">
              <v-divider></v-divider>
            </v-col>
            <text-area
              v-model="escalatoria.comentarios"
              label="Comentarios"
              rows="2">
            </text-area>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixRegistrarEscalatoria"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixContratosEscalatorias from './mixContratosEscalatorias';
import TextField from '@/components/inputs/TextField.vue';
import CustomTextFieldGreen from '@/components/inputs/TextFieldGreen.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import TextArea from '@/components/inputs/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'RegistrarContratoEscalatoria',
  mixins: [mixContratosEscalatorias],
  components: {
    TextField,
    CustomTextFieldGreen,
    DatePicker,
    CustomButton,
    TextArea,
  },
  props: {
    idContrato: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      escalatoria: {
        idContrato: this.idContrato,
        idConvenioModificatorio: null,
        numero: '',
        fechaDel: '',
        fechaAl: '',
        importe: 0,
        porcentajeIva: 16,
        iva: 0,
        total: 0,
        comentarios: '',
      },
    };
  },
  methods: {
    calcularTotal() {
      const {
        importe, porcentajeIva,
      } = this.escalatoria;
      if (importe <= 0) return;

      this.escalatoria.iva = this.$numberRoundDigits((importe * (porcentajeIva / 100)), 2);
      this.escalatoria.total = (this.escalatoria.iva + importe);
    },
    limpiarFormulario() {
      this.$refs.registrarContratoEscalatoria.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">

</style>
